import type {KeyTextField, LinkField} from '@prismicio/client'
import {PrismicLink} from '@prismicio/react'
import React from 'react'
// eslint-disable-next-line boundaries/dependencies -- grandfathered cross-slice import, predates the slice-boundaries rule
import {REPORT_COPYRIGHT_NOTICE} from 'slices/SpendBenchmarks/data/legal'

interface Props {
  eyebrow: KeyTextField
  text: KeyTextField
  linkEyebrow: KeyTextField
  linkTitle: KeyTextField
  linkUrl: LinkField
}

const Methodology: React.FC<Props> = ({eyebrow, text, linkEyebrow, linkTitle, linkUrl}) => (
  <section className="t10-section t10-section-alt" style={{scrollMarginTop: 64}}>
    <div className="t10-wrap">
      <div className="t10-methodology-grid">
        <div>
          {eyebrow && (
            <p className="t10-eyebrow" style={{marginBottom: 20}}>
              {eyebrow}
            </p>
          )}
          {text && <p className="t10-methodology-text">{text}</p>}
        </div>
        {linkTitle && (
          <div>
            <PrismicLink field={linkUrl} className="t10-methodology-link">
              <span>
                {linkEyebrow && <span className="t10-methodology-link-eyebrow">{linkEyebrow}</span>}
                <span className="t10-methodology-link-title">{linkTitle}</span>
              </span>
              <span style={{fontSize: 20, color: '#B4FF44', lineHeight: 1}}>→</span>
            </PrismicLink>
          </div>
        )}
      </div>
      <div className="t10-legal">
        <p className="t10-legal-text">{REPORT_COPYRIGHT_NOTICE}</p>
      </div>
    </div>
  </section>
)

export default Methodology
